import { useCallback } from 'react';
import { enTranslations } from '../locales/en';

export function useTranslation() {
  const t = useCallback((key: string, defaultValue?: string): string => {
    const keys = key.split('.');
    let result: unknown = enTranslations;

    for (const k of keys) {
      if (k === '__proto__' || k === 'constructor' || k === 'prototype') return defaultValue || key;
      if (result && typeof result === 'object' && Object.prototype.hasOwnProperty.call(result, k)) {
        result = (result as Record<string, unknown>)[k];
      } else {
        return defaultValue || key;
      }
    }

    return typeof result === 'string' ? result : defaultValue || key;
  }, []);

  return { t };
}
